import { lazy } from 'react';

export const AddVendorPageAsync = lazy(() => import('./AddVendorPage'));
